export const YOUTUBE_MAX_TITLE_CHARS = 100;
export const YOUTUBE_MAX_DESCRIPTION_CHARS = 5000;
